module.exports = __webpack_public_path__ + "static/media/max-code.bd07beda.png";